/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

const ChevronUp = () => (
  <svg 
    width="14" 
    height="14" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 15l-6-6-6 6"/>
  </svg>
);

export default ChevronUp;

